import { SubTypeOption } from "../../../../../../api/gms/group-category/group-category-api-state";

interface Props {
    labelTitle: string;
    labelName: string;
    hasOtherSpecify?: boolean;
    otherSpecifyValue?: string;
    hasSubType?: boolean;
    sabTypeData?: SubTypeOption[];
    isHasCheckbox?: boolean;
    
}

export default function Selection({ isHasCheckbox = false,labelTitle, labelName, hasOtherSpecify, otherSpecifyValue, hasSubType, sabTypeData }: Props) {
    return (
        <div className='col-span-1 space-y-0'>
            <p className={'text-xs mb-1 text-gray-800 truncate'}>{labelTitle}</p>
            <label  className={`cursor-pointer flex items-center gap-2`}>
                <span className="text-xs font-medium text-gray-800">{labelName}</span>
            </label>
            {hasOtherSpecify && (
                <div className='pl-[22px]'>
                    <span className="flex items-center font-medium text-xs text-gray-800 border-gray-400">{otherSpecifyValue}</span>
                </div>
            )}
            <div className='w-full ml-[10px]'>
                {hasSubType && sabTypeData?.map((data) => (
                    <label key={data.id} className={`cursor-pointer flex items-center gap-2`}>
                        <span className="text-xs font-medium text-gray-800">{data.name}</span>
                    </label>
                ))}
            </div>
        </div>
    )
}
